var exports = {
  "j": "xe7b6e3d6--88ded8--promos",
  "k": "xe7b6e3d6--88ded8--container",
};

module.exports = exports;
